import Stack from "components/Stack/Stack";
import Header from "./Header/Header";

export { Header };

const PageItem = ({ children }) => <Stack>{children}</Stack>;

export default PageItem;
